import { Badge, ToggleOptions } from "@alpacahq/ui/old";

import type { PaymentSchedule } from "../../types";

interface PaymentScheduleToggleProps {
  paymentSchedule: PaymentSchedule;
  onPaymentScheduleChange: (paymentSchedule: PaymentSchedule) => void;
}

export const PaymentScheduleToggle = ({
  paymentSchedule,
  onPaymentScheduleChange,
}: PaymentScheduleToggleProps) => (
  <div className="flex items-center justify-start gap-2">
    <ToggleOptions
      options={[
        { label: "Monthly", value: "monthly" },
        { label: "Yearly", value: "yearly" },
      ]}
      value={paymentSchedule}
      onChange={onPaymentScheduleChange}
    />
    {paymentSchedule === "yearly" && (
      <Badge variant="v2/emerald">1 Month Free</Badge>
    )}
  </div>
);
